import { useRouter } from 'vue-router';

import { stuut } from '@/api';
import { useProfile } from '@/store';

export const canAccessDispute = (dispute: { assignee?: { id: string } }) => {
  const profileStore = useProfile();
  if (profileStore.profile?.is_org_admin) return true;
  if (!dispute?.assignee?.id) return false;
  return dispute.assignee.id === profileStore.profile?.id;
};

export const getActivateDisputeTask = async (disputeId: string) => {
  if (!disputeId) return;

  const dispute = await stuut.disputes.retrieve(disputeId);

  return dispute.openActivateTask;
};

export const useDisputeNavigation = () => {
  const router = useRouter();

  const gotoProposeDisputeTask = async (disputeId: string) => {
    const task = await getActivateDisputeTask(disputeId);
    if (task?.id) {
      router.push({ query: { task_drawer_id: task.id } });
    }
  };

  return { gotoProposeDisputeTask };
};
